import {
  DevtoolsFormatter,
  keyStyle,
  listStyle,
  reference,
  renderCollectionHeader,
} from "./DevtoolsFormatters";
import { ListImpl } from "./ListImpl";

export const ListFormatter: DevtoolsFormatter = {
  header: (o: any) => {
    if (!(o instanceof ListImpl)) {
      return null;
    }
    return renderCollectionHeader(o.length(), "List");
  },

  hasBody: (o: any) => {
    if (!(o instanceof ListImpl)) {
      return false;
    }
    return o.length() !== 0;
  },

  body: (o: any) => {
    if (!(o instanceof ListImpl)) {
      return;
    }

    const children: any[] = [...o].map((value, index) => {
      return ["li", ["span", keyStyle, index + ": "], reference(value)];
    });

    return ["ol", listStyle, ...children];
  },
};
